import { type FormEvent, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { css } from "../../../../styled-system/css";
import { HStack } from "../../../../styled-system/jsx";
import { Button } from "../../core/basic/Button";

interface Props {
  /** The template's fields. */
  children: ReactNode;
  submitLabel: string;
  /** Usually react-hook-form's handleSubmit(…). */
  onSubmit: (event: FormEvent<HTMLFormElement>) => Promise<void>;
  /** Omit to hide the Cancel button. */
  onCancel?: () => void;
  isPending: boolean;
}

/** A program's create or edit form: its fields, then Cancel and submit. */
export const ProgramForm = ({ children, submitLabel, onSubmit, onCancel, isPending }: Props) => {
  const { t } = useTranslation(["common"]);
  return (
    <form
      className={css({ display: "flex", flexDirection: "column", gap: "large" })}
      onSubmit={(event) => void onSubmit(event)}
    >
      {children}
      <HStack justifyContent="end" gap="medium">
        {onCancel && (
          <Button variant="secondary" onPress={onCancel}>
            {t(($) => $.common.actions.Cancel)}
          </Button>
        )}
        <Button type="submit" isPending={isPending}>
          {submitLabel}
        </Button>
      </HStack>
    </form>
  );
};
